<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g id="Group_820" data-name="Group 820" transform="translate(-24 -408)">
      <rect
        id="Rectangle_906"
        data-name="Rectangle 906"
        width="16"
        height="16"
        transform="translate(24 408)"
        fill="none"
      />
      <g
        id="_017-shipping"
        data-name="017-shipping"
        transform="translate(-111 422.123)"
      >
        <path
          id="Path_383"
          data-name="Path 383"
          d="M21.431,15H19.788v1.479a.493.493,0,1,1-.986,0V15H17.159a.493.493,0,0,0-.493.493v3.285a.493.493,0,0,0,.493.493h4.272a.493.493,0,0,0,.493-.493V15.493A.493.493,0,0,0,21.431,15Z"
          transform="translate(127.105 -22.867)"
        />
        <path
          id="Path_384"
          data-name="Path 384"
          d="M22,20.333H10a1.972,1.972,0,1,0,0,3.943H22a1.972,1.972,0,1,0,0-3.943ZM15,22.3a1,1,0,1,1,1,.986A.995.995,0,0,1,15,22.3Zm-6,0a1,1,0,1,1,1,.986A.995.995,0,0,1,9,22.3Zm13,.986a.986.986,0,1,1,1-.986A.995.995,0,0,1,22,23.29Z"
          transform="translate(127 -22.943)"
        />
        <path
          id="Path_385"
          data-name="Path 385"
          d="M15.412,9.667H13.276v1.314a.657.657,0,1,1-1.314,0V9.667H9.826a.493.493,0,0,0-.493.493V18.7a.493.493,0,0,0,.493.493h5.586A.493.493,0,0,0,15.9,18.7V10.16A.493.493,0,0,0,15.412,9.667Z"
          transform="translate(126.981 -22.79)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "tmts-icon",
};
</script>

<style scoped></style>
